import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Services from "../components/Services";
import Pricing from "../components/Pricing";
import PriceCalculator from "../components/PriceCalculator";
import ClientAreaPreview from "../components/ClientAreaPreview";
import AidProgram from "../components/AidProgram";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { useSeo } from "../lib/seo";

export default function Landing() {
  useSeo({
    title: "Lumora | Creazione Siti Web in Abbonamento Mensile — Design, Gestione e SEO",
    description:
      "Lumora crea e gestisce il tuo sito web professionale con un abbonamento mensile da 79€/mese. Design su misura, manutenzione continua e SEO inclusa. Richiedi una consulenza gratuita.",
    path: "/",
  });
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Pricing />
        <PriceCalculator />
        <ClientAreaPreview />
        <AidProgram />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
